@font-face {
  font-family: 'Digital Numbers';
  src: url('/tme/fonts/DS-DIGI.woff2') format('woff2');
  font-weight: var(--font-weight-normal);
  font-style: normal;
  font-display: swap;
}
